export default __webpack_public_path__ + "static/media/time_mgt.fef1dee0.svg";